import { IUpdateMedicaoUseCase } from "../../../presentation/useCases/update/update_medicao_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class UpdateMedicaoUseCase implements IUpdateMedicaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateMedicao(
    IdMedicaoTerceirizacao: number,
    NrMedicaoTerceirizacao: number | null,
    IdContrato: number,
    DataMedicao: Date | null,
    DataDe: Date | null,
    DataAte: Date | null,
    IdFuncionarioResp: number | null,
    Imposto: number | null,
    Acrescimo: number | null,
    Desconto: number | null,
    PercRetencao: number | null,
    ValorRetencao: number | null,
    InformacoesGerais: string | null,
    Status: number | null,
    PgtoProvisionado: boolean | null,
    FornecedorAvaliado: boolean | null,
    Entregue: boolean | null,
    NotaFiscalEntregue: number | null,
    NroNotaFiscal: string | null,
    NrNotaFiscal: string | null,
    IdSubconta: number | null,
    Descricao: string | null,
  ): Promise<void> {
    await this.repository.updateMedicao(
      IdMedicaoTerceirizacao,
      NrMedicaoTerceirizacao,
      IdContrato,
      DataMedicao,
      DataDe,
      DataAte,
      IdFuncionarioResp,
      Imposto,
      Acrescimo,
      Desconto,
      PercRetencao,
      ValorRetencao,
      InformacoesGerais,
      Status,
      PgtoProvisionado,
      FornecedorAvaliado,
      Entregue,
      NotaFiscalEntregue,
      NroNotaFiscal,
      NrNotaFiscal,
      IdSubconta,
      Descricao,
    );
  }
}
